// localStorage can throw (private mode, blocked storage). Only for per-device conveniences.
export function readPref(key, fallback) {
  try {
    return localStorage.getItem(key) ?? fallback
  } catch {
    return fallback
  }
}

export function writePref(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* ignore: preference just won't persist */
  }
}
